import { sumBy } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import { isMarketDisabled, contractOwnershipNum } from '@/utils/helpers';
import { APP_MOBILE_LAYOUT, APP_MOBILE_ORDERBOOK_DISPLAY, APP_PRICE_DISPLAY, UX_CATEGORY } from '@/store/modules/app';
import { UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING } from '@/components/account/settings/settings';
import loaderMixin from '@/mixins/loader';

export default {
  mixins: [
    loaderMixin,
  ],
  props: {
    market: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showMenu: false,
      showSettings: false,
      showSettingsModal: false,
    };
  },
  components: {
    'small-modal': () => import('@/components/generics/modal/small/small.vue'),
    'market-settings-button': () => import('@/components/market/market-settings-button/market-settings-button.vue'),
    'market-settings-modal': () => import('@/components/market/market-settings-modal/market-settings-modal.vue'),
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', ['isTradingEnabled', 'isLayoutMobile', 'isLayoutDesktop']),
    ...mapState('app', ['settingShowOdds', 'settingOrderbookCollapsed', 'settingColorPalette', 'settingMobileLayout']),
    hasOwnership() {
      if (this.market === null || !this.isLoggedIn) return false;
      return sumBy(this.market.contracts, i => contractOwnershipNum(i)) > 0;
    },
    isMarketDisabled() {
      return this.market !== null && isMarketDisabled(this.market);
    },
    pricesTitle() {
      return this.isLayoutMobile ? 'Trade Prices' : 'Last Trade Price';
    },
    titleSecond() {
      return this.settingShowOdds ? 'Odds' : this.pricesTitle;
    },
    titleFourth() {
      return 'Outcome';
    },
    titleSecondMobile() {
      if (this.isMarketDisabled) {
        return 'Outcome';
      }
      return this.settingShowOdds ? 'Odds' : this.pricesTitle;
    },
    isCondensedMobileLayout() {
      return this.settingMobileLayout === APP_MOBILE_LAYOUT.CONDENSED;
    },
    mobileBarClassModifiers() {
      return {
        'market-contracts-list-header-sushi-common-betslip__mobile-bar': true,
        'market-contracts-list-header-sushi-common-betslip__mobile-bar--condensed': this.isCondensedMobileLayout,
        'market-contracts-list-header-sushi-common-betslip__mobile-bar--condensed-disabled': this.isCondensedMobileLayout && this.isMarketDisabled,
      };
    },
    settingsModalOptions() {
      return UX_OPTIONS_WITHOUT_MOBILE_ORDERBOOK_SETTING;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    ...mapActions('app', ['setSettingShowOdds', 'setSettingOrderbookCollapsed', 'setSettingColorPalette', 'setSettingMobileLayout']),
    onMenuToggle() {
      this.showMenu = !this.showMenu;
      this.showSettings = false;
    },
    onSettingsToggle() {
      this.showSettings = !this.showSettings;
      this.showMenu = false
    },
    onClickOutside() {
      this.showMenu = false;
    },
    isOptionDisabled(option) {
      return !!option.disabled;
    },
    setOddsMode(value) {
      this.setSettingShowOdds(value);
      this.showMenu = false;
      this.showSettings = false;
    },
    onSettingOptionClick(category, option) {
      if (this.isOptionDisabled(option) || this.isSelected(category, option.key)) {
        return;
      }

      this.setSettingValue(category, option.key);
    },
    setSettingValue(category, key) {
      if (category === UX_CATEGORY.UXSettingPriceDisplay) {
        this.loaderAdd(document.body);
        this.setSettingShowOdds(key === APP_PRICE_DISPLAY.ODDS)
          .then(() => this.loaderRemove(document.body))
          .catch(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingIsOBCollapsedOnOS) {
        this.loaderAdd(document.body);
        this.setSettingOrderbookCollapsed(
          key === APP_MOBILE_ORDERBOOK_DISPLAY.COLLAPSED)
          .then(() => this.loaderRemove(document.body))
          .catch(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingBuyColorScheme) {
        this.loaderAdd(document.body);
        this.setSettingColorPalette(key)
          .then(() => this.loaderRemove(document.body))
          .catch(() => this.loaderRemove(document.body));
      } else if (category === UX_CATEGORY.UXSettingMobileContractLayout) {
        this.loaderAdd(document.body);
        this.setSettingMobileLayout(key)
          .then(() => this.loaderRemove(document.body))
          .catch(() => this.loaderRemove(document.body));
      }
    },
    isSelected(category, key) {
      switch (category) {
        case UX_CATEGORY.UXSettingPriceDisplay:
          return this.settingShowOdds === (key === APP_PRICE_DISPLAY.ODDS);
        case UX_CATEGORY.UXSettingIsOBCollapsedOnOS:
          return this.settingOrderbookCollapsed ===
            (key === APP_MOBILE_ORDERBOOK_DISPLAY.COLLAPSED);
        case UX_CATEGORY.UXSettingBuyColorScheme:
          return this.settingColorPalette === key;
        case UX_CATEGORY.UXSettingMobileContractLayout:
          return this.settingMobileLayout === key;
        default:
          return false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-contracts-list-header-sushi-common-betslip/market-contracts-list-header-sushi-common-betslip.js